import script from "./DioroomPreRegisterTerms.vue?vue&type=script&setup=true&lang=js"
export * from "./DioroomPreRegisterTerms.vue?vue&type=script&setup=true&lang=js"

import "./DioroomPreRegisterTerms.vue?vue&type=style&index=0&id=5e278ee2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e278ee2"]])

export default __exports__